import { CodebookModel } from 'app/shared/model/shared.model';

export interface Construction {
  idConstruction: number;
  uuid: string;
  constructionBuildingProcedure: CodebookModel[];
  additionalDescription: CodebookModel[];
  buildingPurpose: CodebookModel[];
  buildingPurposeAdditionalDescription: string;
  requirementGroup: CodebookModel[];
  geometryExists: boolean;
  constructionCommencement: CodebookModel[];
  buildingTypeNationalClassification: CodebookModel[];
  accessibilityRating: CodebookModel[];
  accessibilityAppliedMeasure: CodebookModel[];
  greenInfrastructureType: CodebookModel[];
  greenInfrastructureArea: number;
  ordering: number;
}

export interface ConstructionView {
  idConstruction: number;
  idCase: number;
  idConstructionBuildingProcedure: number;
  idBuildingPurpose: number;
  cbpBuildingPurpose: string;
  buildingPurposeAdditionalDescription: string;
  idRequirementGroup: number;
  requirementGroup: string;
  ordering: number;
}

export const initialConstruction = {
  uuid: '',
  constructionBuildingProcedure: [],
  additionalDescription: [],
  buildingPurpose: [],
  buildingPurposeAdditionalDescription: '',
  requirementGroup: [],
  geometryExists: false,
  constructionCommencement: [],
  buildingTypeNationalClassification: [],
  accessibilityRating: [],
  accessibilityAppliedMeasure: [],
  greenInfrastructureType: [],
  greenInfrastructureArea: '',
  ordering: 0,
};
